// Время хода игрока вышло, сервер вот-вот закроет ход: действия уже не
// принимаются (см. utils/gameState/turn/turnInputLock)
export const TEXT_TURN_TIME_IS_UP = 'Время хода вышло';
